export enum HTTPStatusCode {
	OK = 200,
	MASTER_ACCOUNT_CHANGED = 310,
	NEED_AUTHENTICATION = 311,
	FORBIDDEN = 312,
	MASTER_ACCOUNT_NOT_FOUND = 481,
	NO_IMPERSONATION = 482,
}
